import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import UITypography from '@flatfy/supernova2/src/UIKit/Typography';
import FlatsFiltersReset from '../FlatsFiltersReset/FlatsFiltersReset';

const FlatsFiltersHeader = ({ skipKeys }) => {
  const intl = useIntl();

  return (
    <div className="FlatsFiltersHeader">
      <UITypography variant="h4" component="div">
        {intl.formatMessage({ id: 'filters' })}
      </UITypography>
      <FlatsFiltersReset
        body={document.querySelector('body')}
        appearance="ghost-dark"
        skipKeys={skipKeys}
      />
    </div>
  );
};

FlatsFiltersHeader.propTypes = {
  skipKeys: PropTypes.array,
};

export default FlatsFiltersHeader;
